var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10386",
    "data-name": "Group 10386",
    transform: "translate(-637 -3150)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10349",
    "data-name": "Group 10349"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1746",
    "data-name": "Ellipse 1746",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(637 3150)",
    fill: "#1f2133"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47970",
    "data-name": "Path 47970",
    d: "M15.188,4.695c.01.139.01.279.01.419a9.165,9.165,0,0,1-9.227,9.227v0A9.18,9.18,0,0,1,1,12.885a6.6,6.6,0,0,0,.772.047A6.512,6.512,0,0,0,5.8,11.541,3.247,3.247,0,0,1,2.77,9.289a3.232,3.232,0,0,0,1.464-.056,3.243,3.243,0,0,1-2.6-3.179V6.013A3.222,3.222,0,0,0,3.1,6.419a3.247,3.247,0,0,1-1-4.33A9.2,9.2,0,0,0,8.784,5.477a3.246,3.246,0,0,1,5.526-2.958,6.507,6.507,0,0,0,2.059-.787,3.255,3.255,0,0,1-1.426,1.794,6.449,6.449,0,0,0,1.862-.511,6.588,6.588,0,0,1-1.618,1.68Z",
    transform: "translate(649.097 3163.082)",
    fill: "#747377"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitter);
export default __webpack_public_path__ + "static/media/footerTwitter.d386ddfa6907131acd65e19e2c93b8eb.svg";
export { ForwardRef as ReactComponent };